import { render } from "./PolygonModal.vue?vue&type=template&id=4c6b5e75&scoped=true"
import script from "./PolygonModal.vue?vue&type=script&lang=js"
export * from "./PolygonModal.vue?vue&type=script&lang=js"

import "./PolygonModal.vue?vue&type=style&index=0&id=4c6b5e75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6b5e75"]])

export default __exports__